/**
 * OverviewTab — at-a-glance status for the contract.
 *
 * Header strip + phase progress + what's-next + recent activity feed.
 * Uses the existing PhaseAccordion (collapsed by default) for full
 * step-level detail without hiding it from the user.
 */
import React from 'react';
import OrderHeader from '../components/OrderHeader';
import PhaseAccordion from '../components/PhaseAccordion';
import { useManifest } from '../ManifestContext';
import { PHASES, findCurrentStep } from '../fixtures';
import { getOrderMocks, TYPE_LABEL } from '../mocks';
import { Activity as ActivityIcon } from 'lucide-react';

const formatTs = (iso) => new Date(iso).toLocaleString('en-CA', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });

const OverviewTab = ({ onResetDemo }) => {
  const { activeOrder } = useManifest();
  const mocks = getOrderMocks(activeOrder.id);
  const currentStep = findCurrentStep(activeOrder.stepStates || {});

  const recentActivity = mocks.activity.slice(-5).reverse();

  return (
    <div className="manifest-tab-pane">
      <OrderHeader order={activeOrder} onReset={onResetDemo} />

      <div className="manifest-overview-grid">
        <div className="manifest-overview-main">
          <div className="manifest-section-head">
            <h3>Phase progress</h3>
            <span>Click any phase to expand the step list</span>
          </div>
          <div className="manifest-phases">
            {PHASES.map((p) => (
              <PhaseAccordion
                key={p.id}
                phase={p}
                order={activeOrder}
                defaultOpen={p.id === currentStep.phase}
              />
            ))}
          </div>
        </div>

        <div className="manifest-overview-side">
          <div className="manifest-section-head">
            <h3>Recent activity</h3>
            <span>Latest 5 events</span>
          </div>
          <ul className="manifest-activity-mini">
            {recentActivity.map((e) => (
              <li key={e.id} className={`manifest-activity-mini-item type-${e.type.split('.')[0]}`}>
                <div className="manifest-activity-mini-dot" />
                <div className="manifest-activity-mini-main">
                  <div className="manifest-activity-mini-summary">{e.summary}</div>
                  <div className="manifest-activity-mini-meta">
                    {e.actor} · {TYPE_LABEL[e.type] || e.type} · {formatTs(e.ts)}
                  </div>
                </div>
              </li>
            ))}
            {recentActivity.length === 0 && (
              <li className="manifest-activity-empty">
                <ActivityIcon size={14} /> No activity yet.
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
